export default {
    BASE_URL: '/pam/activity',
    api: [
        {
            name: 'dataList',
            desc: '活动数据列表',
            method: 'GET',
            path: '/data/list'
        },
        {
            name: 'detailList',
            desc: '活动明细列表',
            method: 'GET',
            path: '/data/apply/detail/list'
        },
        {
            name: 'detailMain',
            desc: '活动明细查询列表-活动信息',
            method: 'GET',
            path: '/data/apply/detail/main'
        },
        {
            name: 'personalDetail',
            desc: '个人明细查询',
            method: 'GET',
            path: '/data/per/detail'
        },
        {
            name: 'personalDetailExportExcel',
            desc: '个人明细导出excel',
            method: 'GET',
            path: '/data/per/detail/export'
        },
        {
            name: 'applyList',
            desc: '报名列表查询',
            method: 'GET',
            path: '/data/apply/list'
        },
        {
            name: 'applyMain',
            desc: '活动报名查询-活动信息',
            method: 'GET',
            path: '/data/apply/main'
        },
        {
            name: 'applyListExportExcel',
            desc: '报名列表导出excel',
            method: 'GET',
            path: '/data/apply/export'
        },
        {
            name: 'winList',
            desc: '中奖情况列表',
            method: 'GET',
            path: '/data/win/list'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/apis/pam/statistical.js